export default "__VITE_ASSET__C$5Ut_dG__"